import { useNavigate } from 'react-router-dom';
import { useTercerTiempo } from '../context/TercerTiempoContext';

const SERVICIOS_LABELS = {
  asado:     '🥩 Asado',
  cervezas:  '🍺 Cervezas',
  empanadas: '🥟 Empanadas',
  bebidas:   '🥤 Bebidas',
  local:     '🏠 Local propio',
  domicilio: '🚗 A domicilio',
  once:      '☕ Once',
  picoteo:   '🍿 Picoteo',
};

function getWhatsappLink(numero) {
  return 'https://wa.me/' + numero.replace(/\D/g, '');
}

function LinkRRSS({ href, label, estilo }) {
  return (
    <a href={href} target="_blank" rel="noreferrer" style={estilo}>
      {label}
    </a>
  );
}

export default function TercerTiempo() {
  const navigate = useNavigate();
  const { proveedores } = useTercerTiempo();

  return (
    <div style={styles.pagina}>

      <div style={styles.header}>
        <div style={styles.headerInner}>
          <div>
            <div style={styles.titulo}>Tercer Tiempo</div>
            <div style={styles.sub}>
              {proveedores.length > 0
                ? proveedores.length + ' proveedores disponibles en tu zona'
                : 'Proveedores de asados, cervezas y empanadas post partido'}
            </div>
          </div>
          <button
            style={styles.btnRegistrar}
            onClick={() => navigate('/registro-tercer-tiempo')}
          >
            ¿Ofreces este servicio? Regístrate →
          </button>
        </div>
      </div>

      <div style={styles.contenido}>
        {proveedores.length === 0 ? (

          <div style={styles.vacio}>
            <div style={styles.vacioIcono}>🍺</div>
            <div style={styles.vacioTitulo}>Sé el primero en registrarte</div>
            <div style={styles.vacioSub}>
              Los proveedores registrados aparecerán aquí con
              sus servicios y links a redes sociales.
            </div>
            <button
              style={styles.btnRegistrarGrande}
              onClick={() => navigate('/registro-tercer-tiempo')}
            >
              Registrar mi negocio →
            </button>
          </div>

        ) : (
          <>
            {proveedores.map((p, i) => (
              <div key={p.id || i} style={styles.card}>

                <div style={styles.cardHeader}>
                  <div style={styles.crest}>{p.iniciales || '??'}</div>
                  <div style={styles.info}>
                    <div style={styles.nombre}>{p.negocio}</div>
                    <div style={styles.meta}>
                      📍 {p.zona}
                      {p.capacidad ? ' · Hasta ' + p.capacidad + ' personas' : ''}
                    </div>
                    <div style={styles.modalidades}>
                      {p.tieneLocal && <span style={styles.badge}>🏠 Local propio</span>}
                      {p.aDomicilio && <span style={styles.badge}>🚗 A domicilio</span>}
                    </div>
                  </div>
                  <div style={styles.ratingWrap}>
                    <div style={styles.ratingNum}>{p.rating > 0 ? p.rating : '—'}</div>
                    <div style={styles.ratingLabel}>Rating</div>
                  </div>
                </div>

                <div style={styles.seccion}>
                  <div style={styles.seccionLabel}>Servicios</div>
                  <div style={styles.tagsRow}>
                    {(p.servicios || []).map(s => (
                      <span key={s} style={styles.tag}>
                        {SERVICIOS_LABELS[s] || s}
                      </span>
                    ))}
                  </div>
                </div>

                {(p.precioPorPersona || p.precioPorEvento) && (
                  <div style={styles.precioRow}>
                    {p.precioPorPersona && (
                      <div style={styles.precioItem}>
                        <span style={styles.precioNum}>
                          ${Number(p.precioPorPersona).toLocaleString('es-CL')}
                        </span>
                        <span style={styles.precioLabel}> / persona</span>
                      </div>
                    )}
                    {p.precioPorEvento && (
                      <div style={styles.precioItem}>
                        <span style={styles.precioNum}>
                          ${Number(p.precioPorEvento).toLocaleString('es-CL')}
                        </span>
                        <span style={styles.precioLabel}> / evento</span>
                      </div>
                    )}
                  </div>
                )}

                {p.rrss && (
                  <div style={styles.rrssSeccion}>
                    <div style={styles.seccionLabel}>Ver en redes sociales</div>
                    <div style={styles.rrssLinks}>
                      {p.rrss.instagram && (
                        <LinkRRSS href={p.rrss.instagram} label="📸 Instagram" estilo={styles.rrssLink} />
                      )}
                      {p.rrss.facebook && (
                        <LinkRRSS href={p.rrss.facebook} label="👤 Facebook" estilo={styles.rrssLink} />
                      )}
                      {p.rrss.tiktok && (
                        <LinkRRSS href={p.rrss.tiktok} label="🎵 TikTok" estilo={styles.rrssLink} />
                      )}
                      {p.rrss.whatsapp && (
                        <LinkRRSS href={getWhatsappLink(p.rrss.whatsapp)} label="💬 WhatsApp" estilo={styles.rrssLinkWa} />
                      )}
                    </div>
                  </div>
                )}

                {p.descripcion && (
                  <div style={styles.descripcion}>"{p.descripcion}"</div>
                )}

              </div>
            ))}

            <div
              style={styles.registrarCard}
              onClick={() => navigate('/registro-tercer-tiempo')}
            >
              <div style={styles.registrarIcono}>+</div>
              <div style={styles.registrarTitulo}>Registra tu negocio</div>
              <div style={styles.registrarSub}>
                Llega a equipos activos buscando el mejor Tercer Tiempo.
              </div>
              <div style={styles.registrarBtn}>Registrarme →</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  pagina: { minHeight: '100vh', background: '#F4F6FA' },
  header: {
    background: '#0D1117', padding: '24px 32px',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    marginBottom: 24,
  },
  headerInner: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 32, fontWeight: 800, color: 'white', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)',
    fontFamily: "'Barlow', sans-serif",
  },
  btnRegistrar: {
    background: '#FF6B1A', color: 'white', border: 'none',
    borderRadius: 10, padding: '10px 18px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 15, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap',
  },
  contenido: {
    padding: '0 32px 32px',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
    gap: 16,
  },
  vacio: {
    gridColumn: '1 / -1',
    textAlign: 'center', padding: '60px 20px',
  },
  vacioIcono: { fontSize: 56, marginBottom: 16 },
  vacioTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 8,
  },
  vacioSub: {
    fontSize: 14, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
    maxWidth: 400, margin: '0 auto 24px', lineHeight: 1.6,
  },
  btnRegistrarGrande: {
    background: '#FF6B1A', color: 'white', border: 'none',
    borderRadius: 12, padding: '13px 28px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, cursor: 'pointer',
  },
  card: {
    background: 'white', border: '1px solid #E8ECF4',
    borderRadius: 16, padding: '20px',
  },
  cardHeader: {
    display: 'flex', alignItems: 'flex-start',
    gap: 14, marginBottom: 16,
  },
  crest: {
    width: 48, height: 48, borderRadius: 12, flexShrink: 0,
    background: 'linear-gradient(135deg, #FF6B1A, #FF9500)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, color: 'white',
  },
  info: { flex: 1 },
  nombre: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 20, fontWeight: 800, color: '#141922', marginBottom: 3,
  },
  meta: {
    fontSize: 12, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 6,
  },
  modalidades: { display: 'flex', gap: 5, flexWrap: 'wrap' },
  badge: {
    background: '#FFF7ED', color: '#92400E',
    fontSize: 10, fontWeight: 700, padding: '2px 8px',
    borderRadius: 20, fontFamily: "'Barlow', sans-serif",
  },
  ratingWrap: { textAlign: 'right', flexShrink: 0 },
  ratingNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 28, fontWeight: 800, color: '#FF6B1A', lineHeight: 1,
  },
  ratingLabel: {
    fontSize: 10, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
    textTransform: 'uppercase', letterSpacing: '0.04em',
  },
  seccion: { marginBottom: 12 },
  seccionLabel: {
    fontSize: 10, fontWeight: 700, color: '#9BA5B7',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 6,
  },
  tagsRow: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  tag: {
    background: '#FFF7ED', border: '1px solid #FED7AA',
    borderRadius: 6, padding: '3px 9px',
    fontSize: 11, fontWeight: 600, color: '#92400E',
    fontFamily: "'Barlow', sans-serif",
  },
  precioRow: {
    display: 'flex', gap: 16, marginBottom: 12,
    borderTop: '1px solid #F4F6FA', paddingTop: 12,
  },
  precioItem: {},
  precioNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 22, fontWeight: 800, color: '#FF6B1A',
  },
  precioLabel: {
    fontSize: 12, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
  },
  rrssSeccion: { marginBottom: 10 },
  rrssLinks: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  rrssLink: {
    background: '#F4F6FA', border: '1px solid #E8ECF4',
    borderRadius: 8, padding: '5px 10px',
    fontSize: 11, fontWeight: 600, color: '#4A5568',
    textDecoration: 'none', fontFamily: "'Barlow', sans-serif",
  },
  rrssLinkWa: {
    background: '#F0FDF4', border: '1px solid #86EFAC',
    borderRadius: 8, padding: '5px 10px',
    fontSize: 11, fontWeight: 600, color: '#16A34A',
    textDecoration: 'none', fontFamily: "'Barlow', sans-serif",
  },
  descripcion: {
    fontSize: 12, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif",
    fontStyle: 'italic', lineHeight: 1.5,
    borderTop: '1px solid #F4F6FA', paddingTop: 10,
  },
  registrarCard: {
    background: '#0D1117',
    border: '2px dashed rgba(255,255,255,0.1)',
    borderRadius: 16, padding: '32px 20px',
    textAlign: 'center', cursor: 'pointer',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', gap: 10,
  },
  registrarIcono: {
    width: 48, height: 48, borderRadius: '50%',
    background: 'rgba(255,107,26,0.15)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 24, color: '#FF6B1A', fontWeight: 700,
  },
  registrarTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: 'white',
  },
  registrarSub: {
    fontSize: 12, color: 'rgba(255,255,255,0.35)',
    fontFamily: "'Barlow', sans-serif",
    lineHeight: 1.5, maxWidth: 260,
  },
  registrarBtn: {
    fontSize: 13, fontWeight: 700, color: '#FF6B1A',
    fontFamily: "'Barlow Condensed', sans-serif", marginTop: 4,
  },
};